import * as actionTypes from '../constants';
const initState = {
	loading: false
}
const app = (state = initState, action) => {
	switch (action.type) {
		case actionTypes.SET_LOADING:
			return {
				...state,
				loading: action.value
			};
		default:
			return state;
	}
};

export { app };
